import {Layout, Anchor, Typography} from 'antd';
import React, {useState} from 'react';
import appColors from '../../style/theme';
import Biomarkers from './Biomarkers';
import ContributionPart from './ContributionPart';
import References from './References';
import General from './General';

const {Link} = Anchor;
const {Sider, Content} = Layout;
const Text = Typography;

const handleClick = (e, link) => {
  e.preventDefault();
  console.log(link);
};
const ContributionLogic = () => {
  const [backI, setBackI] = useState('transparent');
  const [backII, setBackII] = useState('transparent');
  const [backIII, setBackIII] = useState('transparent');
  const [backIV, setBackIV] = useState('transparent');
  const ChangeAnchor = (key) => {
    console.log(key);
    if (key === '#SafetyLab') {
      setBackI(appColors['ColorA']);
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
    } else if (key === '#SafetyProto') {
      setBackI('transparent');
      setBackII(appColors['ColorA']);
      setBackIII('transparent');
      setBackIV('transparent');
    } else if (key === '#Ethics') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII(appColors['ColorA']);
      setBackIV('transparent');
    } else if (key === '#Training') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV(appColors['ColorA']);
    }
  };
  return (
    <Layout style={{background: 'transparent'}}>
      <Sider style={{background: 'transparent'}}>
        <Anchor onClick={handleClick} offsetTop={75} onChange={ChangeAnchor} style={{background: 'transparent'}}>
          <Link href='#SafetyLab' title={<Content className='ContentAnchor' style={{borderColor: backI}}><Text style={{color: appColors['ColorA'], fontSize: '2vh'}}>General Description</Text></Content>}/>
          <Link href='#SafetyProto' title={<Content className='ContentAnchor' style={{borderColor: backII}}><Text style={{color: appColors['ColorA'], fontSize: '3vh'}}>Contribution</Text></Content>}/>
          <Link href='#Ethics' title={<Content className='ContentAnchor' style={{borderColor: backIII}}><Text style={{color: appColors['ColorA'], fontSize: '3vh'}}>Biomarkers</Text></Content>}/>
          <Link href='#Training' title={<Content className='ContentAnchor' style={{borderColor: backIV}}><Text style={{color: appColors['ColorA'], fontSize: '3vh'}}>References</Text></Content>}/>
        </Anchor>
        <p style={{color: appColors['ColorA'], pointerEvents: 'none', fontSize: '2vh', top: '45vh', left: '5vh', textAlign: 'center', position: 'sticky'}}> C&nbsp;<br/> O&nbsp;<br/> N&nbsp;<br/> T&nbsp;<br/> R&nbsp;<br/> I&nbsp;<br/> B&nbsp;<br/> U&nbsp;<br/> T&nbsp;<br/> I&nbsp;<br/> O&nbsp;<br/> N&nbsp;<br/> S&nbsp;</p>
      </Sider>
      <Layout style={{margin: '1% 1% 0 1%', width: 'fit-content'}}>
        <Layout style={{background: appColors['ColorX'], height: '1px'}} />
        <Layout className='PurpBack' style={{background: appColors['ColorG']}}>
          <Layout style={{margin: '0 0 0 0', background: 'transparent'}}>
            <div id='SafetyLab'>
              <General/>
            </div>
            <div id='SafetyProto'>
              <ContributionPart/>
            </div>
            <div id='Ethics'>
              <Biomarkers/>
            </div>
            <div id='Training'>
              <References/>
            </div>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default ContributionLogic;
